import { useEffect } from 'react';

interface SeoConfig {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  jsonLd?: Record<string, unknown>[];
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSeo(config: SeoConfig) {
  useEffect(() => {
    document.title = config.title;
    setMeta('name', 'description', config.description);
    setMeta('name', 'keywords', config.keywords);
    setMeta('name', 'robots', 'index,follow');
    setLink('canonical', config.canonical);

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', config.title);
    setMeta('property', 'og:description', config.description);
    setMeta('property', 'og:url', config.canonical);
    setMeta('property', 'og:site_name', '17C吃瓜站');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', config.title);
    setMeta('name', 'twitter:description', config.description);

    const existing = document.getElementById('page-jsonld');
    if (existing) existing.remove();

    if (config.jsonLd && config.jsonLd.length > 0) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'page-jsonld';
      script.textContent = JSON.stringify(config.jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById('page-jsonld');
      if (script) script.remove();
    };
  }, [config]);
}